import React, { Fragment } from 'react';
import { Question } from './Question'
import { useSelector } from 'react-redux';
import LoadingIndicator from '../../loading-indicator/loading-indicator';

export const QuestionsList = ({ questionnaire }) => {
    const questionnaire_list = useSelector(state => state.questionnaire_list);

    return (
        <>
            { questionnaire_list && !questionnaire_list.isPending &&
            <Fragment>
            {questionnaire.answered_items && questionnaire.answered_items.map((question, index) =>
                    <div key={question.id} className='mb-3 border-bottom'>
                        <Question
                            question={question}
                            index={index}
                            questionnaie_id={questionnaire.questionnaire.id}
                            questionnaire={questionnaire.questionnaire}
                            locked={questionnaire.questionnaire.blocked}
                        />
                    </div>
                )
            }
            </Fragment>
            }
            {questionnaire_list && questionnaire_list.isPending && <LoadingIndicator/>}
        </>
    )
}
